var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ErrorBoundary from "./ErrorBoundary";
import { ConfigProvider } from "../hooks/useConfig";
import queryClient from "../const/queryClient";
import AccountCardMFE from "./AccountCardMFE/AccountCardMFE";
import AccountCardContextProvider from "../context/AccountCardContext";
var AccountCardMFERoot = function (_a) {
    var mfeConfig = _a.mfeConfig, accountId = _a.accountId, currentChannel = _a.currentChannel, eventHandlers = _a.eventHandlers, isQueryClientPresent = _a.isQueryClientPresent, isExpandedByDefault = _a.isExpandedByDefault, handleAccountLink = _a.handleAccountLink, featureFlags = _a.featureFlags, shouldCallCreditAccountsQuery = _a.shouldCallCreditAccountsQuery;
    /** Render a QueryClientProvider if there is no query client present in consumer */
    var renderQueryClientProvider = !isQueryClientPresent;
    var mfeWithConfig = (_jsx(ConfigProvider, __assign({ value: mfeConfig }, { children: _jsxs(AccountCardContextProvider, __assign({ initialState: { featureFlags: featureFlags } }, { children: [_jsx(AccountCardMFE, { mfeConfig: mfeConfig, accountId: accountId, currentChannel: currentChannel, eventHandlers: eventHandlers, isExpandedByDefault: isExpandedByDefault, handleAccountLink: handleAccountLink, featureFlags: featureFlags, shouldCallCreditAccountsQuery: shouldCallCreditAccountsQuery }), renderQueryClientProvider ? _jsx(ReactQueryDevtools, {}) : null] })) })));
    return (_jsx(ErrorBoundary, { children: renderQueryClientProvider ? (_jsx(QueryClientProvider, __assign({ client: queryClient }, { children: mfeWithConfig }))) : (mfeWithConfig) }));
};
export default AccountCardMFERoot;
//# sourceMappingURL=index.js.map